export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CONTACT_SUCCESS = 'CONTACT_SUCCESS';
export const CONTACT_FAIL = 'CONTACT_FAIL';
export const APPLY_SUCCESS = 'APPLY_SUCCESS';
export const APPLY_FAIL = 'APPLY_FAIL';
